import React from 'react';
import Image from './Image';
import Video from './Video';
import './Phone.scss';

export const Phone = ({ screen, placeholder, isVideo}) => {
  return (
    <div className="phone">
      {isVideo ? (
        <Video
          src={screen}
          id="phone-video"
          placeholder={placeholder && placeholder.localFile && placeholder.localFile.childImageSharp.fixed.base64}
        />
      ) : (
        <Image image={{ localFile: screen }} />
      )}
    </div>
  );
};
